import React, { type CSSProperties, useLayoutEffect, useRef } from 'react';

import { KIT_CSS } from './viewDocument';

const DROPPED = 'script,iframe,object,embed,link,meta,base,form,style';
const DROPPED_ATTRIBUTE = /^(on.*|href|src|srcset|xlink:href|action|formaction)$/i;
const PAGE_CSS = 'svg, figure, tr, .k-fig { break-inside: avoid; } h1, h2, h3, h4, h5, h6 { break-after: avoid; }';

function staticMarkup(html: string): string {
  const parsed = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
  parsed.querySelectorAll(DROPPED).forEach((node) => node.remove());
  parsed.querySelectorAll('*').forEach((element) => [...element.attributes].forEach((attribute) => DROPPED_ATTRIBUTE.test(attribute.name) && element.removeAttribute(attribute.name)));
  return parsed.body.firstElementChild?.innerHTML ?? '';
}

const hosted = (css: string) => css.replace(/(^|[\s,{}])(html|body|:root)(?=[\s{,.:#[>~+]|$)/g, '$1:host');

type PrintedViewProps = { html: string; css?: string; tokens: Record<string, string> };

export default function PrintedView({ html, css, tokens }: PrintedViewProps) {
  const host = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    if (!host.current) return;
    const root = host.current.shadowRoot ?? host.current.attachShadow({ mode: 'open' });
    root.innerHTML = `<style>${KIT_CSS}${hosted(css ?? '')}${PAGE_CSS}</style><div id="lens-view">${staticMarkup(html)}</div>`;
  }, [html, css]);
  return <div className="view-print" ref={host} style={tokens as CSSProperties} />;
}
